import React, { useState } from "react";
// import { Button } from "@mui/material";
import FormTemplatePage from "./FormTemplatePage";
import api from "../../api/api";
import { red, blue, green, purple, orange } from "@mui/material/colors";
import AodIcon from "@mui/icons-material/Aod";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { ToastContainer, toast } from "react-toastify";
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  Paper,
  useTheme,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
} from "@mui/material";

const Feedback = () => {
  const [openFormTemplateDialog, setOpenFormTemplateDialog] = useState(false);
  const [data, setData] = useState([]);
  //console.log("dataaaaaaa---------", data);
  const [editing, setEditing] = useState(false);

  const form_template_on_open = (item, action) => {
    //console.log("update-------->", item);
    setEditing(action === "update");
    setOpenFormTemplateDialog(true);
    setEditData(item);
    // setOpenFormTemplateDialog(false);
  };

  const form_template_on_close = () => {
    setOpenFormTemplateDialog(false);
    setEditing(false);
    setEditData(null);
  };

  const form_template_on_save = (formdata) => {
    //console.log("--> On Main Page FormData: ", formdata);
  };

  const [usertype, setUsertype] = useState("");
  //console.log("usertype===>", usertype);
  const usertype_select_option_list = [
    { id: 0, value: "fellow", text: "Educator" },
    { id: 1, value: "", text: "Anganwadi" },
    { id: 2, value: "school", text: "School" },
    { id: 3, value: "cci", text: "CCI" },
  ];

  const usertype_select_onchange = async (event) => {
    setUsertype(event.target.value);
    try {
      const response = await api.get("getAllMasterTchSurvey");
      // Assuming the response.data is an array, you can update the data state.
      setData(response.data);
      //console.log("response---------", response.data);
    } catch (error) {
      // Handle any errors here.
      console.error("Error fetching data:", error);
      if (error.response.status === 500) {
        toast.error("Internal server error.");
      } else if (error.response.status === 504) {
        toast.error("Server timeout. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", error);
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const [editData, setEditData] = useState(null);

  const handleVertMenuClose = () => {
    // setAnchorEl(null);
  };

  const delete_content_button_click = async (item) => {
    //console.log("surveyId-->", item.surveyId);
    handleVertMenuClose();

    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this record!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const params = {
          surveyId: item.surveyId,
        };

        await api.delete(`deleteMasterTchSurvey/${params.surveyId}`);
        const response = await api.get("getAllMasterTchSurvey");
        setData(response.data);
        toast.success("successfully deleted");
      }
    } catch (error) {
      console.error("An error occurred:", error);

      if (error.response.status === 500) {
        toast.error("Internal server error.");
      } else if (error.response.status === 504) {
        toast.error("Server timeout. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", error);
        Swal.fire({
          title: "Error",
          text: "An error occurred while deleting the record.",
          icon: "error",
        });
      }
    }
  };

  const updateTemplate = async (updatedData) => {
    try {
      //console.log("update1-------->", updatedData);

      const response = await api.put(`updateMasterTchSurvey`, updatedData);

      //console.log("update response---->", response.data);

      if (response.status === 200) {
        const responseData = await api.get("getAllMasterTchSurvey");
        toast.success("Template updated successfully");
        setData(responseData.data);
      }
    } catch (error) {
      console.error("Error updating template:", error);
      if (error.response.status === 500) {
        toast.error("Internal server error.");
      } else if (error.response.status === 504) {
        toast.error("Server timeout. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", error);
        toast.error("An unexpected error occurred. Please try again later.");
      }
      toast.error("Failed to update template");
    } finally {
      setOpenFormTemplateDialog(false);
    }
  };

  const form_save_button_on_click = async (
    stackData,
    formTitle,
    formDescription,
    formId
  ) => {
    const form_data = {
      surveyDescription: formDescription,
      surveyData: stackData,
      surveyId: "" + new Date().getTime(),
      usertype: "fellow",
      surveyName: formTitle,
    };
    //console.log("form_data---->", form_data);

    try {
      const response = await api.post(`createMasterTchSurvey`, form_data);
      //console.log("create response---->", response.data, response.status);

      if (response.status === 201) {
        toast.success("Template created successfully");
        const responseData = await api.get("getAllMasterTchSurvey");
        // Additional logic here if needed
        setData(responseData.data);
      }
    } catch (error) {
      console.error("Error creating template:", error);
      if (error.response.status === 500) {
        toast.error("Internal server error.");
      } else if (error.response.status === 504) {
        toast.error("Server timeout. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", error);
        toast.error("An unexpected error occurred. Please try again later.");
      }
      // Additional error handling if needed
    } finally {
      setOpenFormTemplateDialog(false);
    }
  };

  // const form_save_button_on_click = async (
  //   stackData,
  //   formTitle,
  //   formDescription,
  //   formId
  // ) => {
  //   if (editing) {
  //     //console.log("stackData---->", editData);
  //     //console.log("stackData2---->", stackData);
  //     //console.log("stackData3---->", formTitle, formDescription);
  //     // If in editing mode, call the update function
  //     const updatedData = {
  //       ...editData,
  //       surveyData: stackData,
  //     };
  //     updateTemplate(updatedData);
  //   } else {
  //     // If not in editing mode, create a new form
  //     const form_data = {
  //       surveyDescription: formDescription,
  //       surveyData: stackData,
  //       surveyId: "" + new Date().getTime(),
  //       usertype: "fellow",
  //       surveyName: formTitle,
  //     };
  //     //console.log("form_data---->", form_data);

  //     api.post(`createMasterTchSurvey`, form_data).then(
  //       (response) => {
  //         //console.log("create response---->", response.data);
  //         toast.success("Changes made successfully");
  //         if (response.status === 200) {
  //           api.get("getAllMasterTchSurvey");
  //         }
  //       },
  //       (err) => {
  //         //console.log(err);
  //         // toast.error("Enter a valid feedback");
  //       }
  //     );
  //   }

  //   setOpenFormTemplateDialog(false);
  // };

  return (
    <>
      <div>
        <FormControl
          sx={{ m: 1 }}
          style={{ width: "130px", marginTop: "30px" }}
          size="small"
        >
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Language"
            onChange={usertype_select_onchange}
          >
            <MenuItem>None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.id} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {usertype ? (
        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => form_template_on_open(null, "create")}
          >
            Create Survey
          </Button>
          <FormTemplatePage
            open={openFormTemplateDialog}
            onSave={form_template_on_save}
            onClose={form_template_on_close}
            form_save_button_on_click={form_save_button_on_click}
            editData={editData}
            updateTemplate={updateTemplate}
          />
        </div>
      ) : null}

      {usertype && data && data.length > 0 ? (
        <Paper style={{ width: 700 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sl. No.</TableCell>
                <TableCell>Survey Name</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            {usertype && data && data.length > 0
              ? data.map((item, index) => (
                  <TableBody key={index}>
                    <TableRow>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.surveyName}</TableCell>
                      <TableCell
                        style={{
                          width: -20,
                          paddingLeft: "-130px",
                          marginLeft: "-120px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              width: -20,
                              paddingLeft: "-130px",
                              marginLeft: "-120px",
                            }}
                          >
                            <Button
                              style={{ marginLeft: 65 }}
                              onClick={() => {
                                setEditData(item);
                                form_template_on_open(item, "update");
                              }}
                            >
                              <EditIcon style={{ color: "blue" }}></EditIcon>
                            </Button>
                          </div>

                          <Button
                            onClick={() => delete_content_button_click(item)}
                          >
                            <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ))
              : null}
          </Table>
        </Paper>
      ) : null}
    </>
  );
};

export default Feedback;
